export default __webpack_public_path__ + "media/images/chevron-left-8188ac0eade45caedb98735047060965.svg";